import { useI18nContext } from "@hopper-b2b/i18n";
import { PassengerCountCard } from "../PassengerCard";
import { FlightItinerary } from "../FlightItinerary";
import { PassengerTypes } from "@hopper-b2b/types";

import "./styles.scss";
import { PriceBreakdown } from "../PriceBreakdown";
import {
  Airport,
  FareDetailsV2,
  TripDetailsV2,
} from "@b2bportal/price-freeze-api";

export interface IDetailsBlock {
  passengerMap: { [key in PassengerTypes]?: number };
  onPassengerCountChange?: (val: { [key in PassengerTypes]?: number }) => void;
  tripDetails: TripDetailsV2;
  fareDetails: FareDetailsV2;
  priceFreezeTotalAmount: string;
  airports?: { [key: string]: Airport };
  assets?: Record<string, any>;
}

export const DetailsBlock = (props: IDetailsBlock) => {
  const {
    passengerMap,
    onPassengerCountChange,
    tripDetails,
    fareDetails,
    priceFreezeTotalAmount,
    airports,
    assets,
  } = props;
  const { t } = useI18nContext();

  return (
    <div className="checkout-itinerary-block checkout-block">
      <div className="title">{`${t("priceFreezePurchase.details.title")}`}</div>
      <PassengerCountCard
        passengerMap={passengerMap}
        onPassengerCountChange={onPassengerCountChange}
      />
      <FlightItinerary
        tripDetails={tripDetails}
        fareDetails={fareDetails}
        airports={airports}
        assets={assets}
      />
      <PriceBreakdown amount={priceFreezeTotalAmount} />
    </div>
  );
};
